"use client";
import React from "react";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";

const features = [
  "Patented Tablets that enable truly paperless exams",
  "Proven and patented workflow to ensure hassle free examination",
  "High-end encryption technology to secure question papers",
  "Biometric authentication (registration and admit candidates)",
  "Multi-format question support (MCQs, descriptive, diagrams)",
];

const advantages = [
  "Secure and offline capable tablet PCs",
  "AI proctoring/surveillance possibilities",
  "Anti-cheating tech and processes",
  "Fast results processing and analytics",
  "Scalable for any exam size",
  "Eco-friendly as it’s completely paperless",
  "Cost-effective in the long run",
];

const Digitab = () => {
  return (
    <div className="bg-white text-dark  ml-50 mr-50">
      {/* Header Section */}
      <section className=" py-5">
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="fw-bold fs-3 text-primary"
        >
          Paperless Examination
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="mt-3 fs-5 text-black"
        >
          Transform your examination process with our cutting-edge solution{" "}
          <span className="fw-semibold text-primary">DigiTAB</span> –
          Tablet-Based Paperless Examination Solution, designed to deliver
          seamless, secure, and scalable assessments for certification bodies.
          Our innovative platform eliminates the hassles of paper-based exams by
          providing a robust solution and infrastructure setup to conduct exams
          instantly with encrypted question papers delivered on tablets after
          candidate authentication, ensuring zero leaks and maximum integrity.
        </motion.p>
      </section>

      {/* Features Section */}
      <section className=" py-5" style={{fontSize:'15px'}}>
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="fw-bold h2 text-primary text-center mb-4"
        >
          Key Features
        </motion.h2>

        <div className="row g-4">
          {features.map((feature, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              viewport={{ once: true }}
              className="col-sm-6 col-md-4"
            >
              <div className="card shadow-sm border-0 h-100">
                <div className="card-body d-flex align-items-start gap-2">
                  <FaCheckCircle className="text-success mt-1 me-2" />
                  <span className="text-black">{feature}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Preface Highlight Section */}
      <section className="container py-5">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="p-4 bg-success bg-opacity-10 border-start border-4 border-success rounded shadow-sm"
        >
          <h3 className="h4 fw-semibold text-success mb-3">Solution Preface</h3>
          <p className="text-black mb-3">
            Integrated with AI-powered exam surveillance, live monitoring, and
            biometric authentication, we prevent malpractice while offering a
            smooth exam experience. Tablets with high-end gorilla glass ensure
            that candidates feel like writing on paper.
          </p>
          <p className="text-black mb-3">
            Once candidates complete the exam and it is approved by the
            invigilator, responses are instantly converted into PDFs ready for
            evaluation. This ensures faster evaluation and error-free results.
          </p>
          <p className="text-black">
            DigiTAB is ideal for high-stakes exams as it is cost-effective in
            the long run, eco-friendly, and easy to deploy since it requires
            minimal infrastructure.
          </p>
        </motion.div>
      </section>

      {/* Advantages Section */}
      <section className="text-white py-5" style={{ backgroundColor: "#0a1530" }}>
        <div className="container text-center">
          <motion.h2
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="fw-bold h2"
          >
            Key Advantages
          </motion.h2>
          <div className="row g-4 mt-4 text-start">
            {advantages.map((adv, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: idx * 0.1, duration: 0.6 }}
                viewport={{ once: true }}
                className="col-sm-6 col-md-4"
              >
                <div className="p-3 rounded bg-white bg-opacity-25 d-flex align-items-start gap-2 h-100">
                  <FaCheckCircle className="text-success mt-1 me-2" />
                  <span className="text-white" >{adv}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Digitab;
